import React, {memo, useEffect, useState} from 'react';
import classNames from 'classnames';
import placeholder from '~/assets/images/noimage-placeholder.svg';
import {UiBox, UiIcon} from '~/components/elements';
import {AiOutlineClose} from 'react-icons/all';
import {Image, ImageProps} from '@chakra-ui/react';

export interface UiImageProps extends ImageProps {
  url: string;
  inline?: boolean;
  onClose?: (arg0: any) => any;
  containerClasses?: string;
}

export const UiImage = memo(function AppImage({
  url,
  containerClasses,
  onClose,
  inline,
  objectFit = 'contain',
  ...rest
}: UiImageProps) {
  const [imageSrc, setImageSrc] = useState(url || placeholder);

  useEffect(() => {
    setImageSrc(url || placeholder);
  }, [url]);

  return (
    <div className={classNames(containerClasses, {inline})}>
      <Image
        src={imageSrc}
        objectFit={objectFit}
        onError={() => setImageSrc(placeholder)}
        className={classNames({inline})}
        {...rest}
      />
      {/* Work in progress */}
      {!!onClose && imageSrc !== placeholder && (
        <UiBox size="mini" onClick={onClose} cursor="pointer">
          <UiIcon as={AiOutlineClose} color="red" />
        </UiBox>
      )}
    </div>
  );
});
